import React, { useState } from "react";

const ActionButtons = ({ onSave, onDownloadPdf }) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [error, setError] = useState(null);

  const handleDownloadWithSave = async () => {
    try {
      setIsDownloading(true);
      setError(null);
      
      // First save the order
      await onSave();
      
      // Then download the PDF
      onDownloadPdf();
      
    } catch (error) {
      console.error("Failed to save order before download:", error);
      setError(error.message || "Failed to save order. Please check all required fields.");
      
      // You could also show a confirmation dialog to proceed without saving
      const shouldContinue = window.confirm(
        "Unable to save the order. Do you still want to download the PDF? (Note: It will be based on current unsaved data)"
      );
      
      if (shouldContinue) {
        onDownloadPdf();
      }
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6 slide-in">
      {error && (
        <div className="col-span-1 md:col-span-2 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
          {error}
        </div>
      )}
      
      <button
        onClick={onSave}
        disabled={isDownloading}
        className="bg-gradient-to-r from-green-500 to-emerald-600 text-white font-bold py-4 px-8 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-200 flex items-center justify-center space-x-3 group disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:translate-y-0"
      >
        <svg className="w-6 h-6 group-hover:scale-110 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
        <span className="text-lg">Save Order</span>
      </button>
      
      <button
        onClick={handleDownloadWithSave}
        disabled={isDownloading}
        className="bg-gradient-to-r from-red-500 to-pink-600 text-white font-bold py-4 px-8 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-200 flex items-center justify-center space-x-3 group disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:translate-y-0"
      >
        {isDownloading ? (
          <>
            <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span className="text-lg">Saving & Downloading...</span>
          </>
        ) : (
          <>
            <svg className="w-6 h-6 group-hover:scale-110 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <span className="text-lg">Download PDF</span>
          </>
        )}
      </button>
    </div>
  );
};

export default ActionButtons;